const styleSheet = {
  container: {
    '& p': {
      fontSize: '14px',
      color: '#051D39',
      textAlign: 'center',
    },
    '& p span': {
      fontFamily: "'Museo Sans', sans-serif",
      fontWeight: 700,
    },
  },
  controls: {
    marginTop: '61px',
    display: 'flex',
    justifyContent: 'center',
    '& > *': {
      marginRight: '32px',
    },
    '& :last-child': {
      marginRight: 0,
    },
  },
  error: {
    color: '#FF6969',
    fontSize: '12px',
    letterSpacing: 0,
    marginTop: '5px',
  },
};
export default styleSheet;
